/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { Create5Params, FundingSourceRequest, FundingSourceResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiTopUpFundingSourceController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-top-up-funding-source-controller
   * @name FindAll1
   * @request GET:/api/v1/top-ups/funding-sources
   */
  findAll = (params: RequestParams = {}) =>
    this.http.request<FundingSourceResponse[], any>({
      path: `/v1/top-ups/funding-sources`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAllPath = '/v1/top-ups/funding-sources'
  static findAllMethod = 'GET'
  /**
   * No description
   *
   * @tags api-top-up-funding-source-controller
   * @name Create5
   * @request POST:/api/v1/top-ups/funding-sources
   */
  create = (query: Create5Params, data: FundingSourceRequest, params: RequestParams = {}) =>
    this.http.request<FundingSourceResponse, any>({
      path: `/v1/top-ups/funding-sources`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/top-ups/funding-sources'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags api-top-up-funding-source-controller
   * @name SetDefault
   * @request POST:/api/v1/top-ups/funding-sources/{id}/default
   */
  setDefault = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/top-ups/funding-sources/${id}/default`,
      method: 'POST',
      ...params,
    })

  static setDefaultPath = '/v1/top-ups/funding-sources/${id}/default'
  static setDefaultMethod = 'POST'
  /**
   * No description
   *
   * @tags api-top-up-funding-source-controller
   * @name Delete3
   * @request DELETE:/api/v1/top-ups/funding-sources/{id}
   */
  delete = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/top-ups/funding-sources/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deletePath = '/v1/top-ups/funding-sources/${id}'
  static deleteMethod = 'DELETE'
}
